/**
 * Brand palette — aligned with tamagui `light` theme + auth screens.
 * Use these instead of hardcoding hex values in UI.
 */
export const BRAND_COLORS = {
  pageBg: "#F4F1ED",
  cardBg: "#FFFFFF",
  text: "#0D0D0D",
  muted: "#5C5854",
  border: "#D2CCC5",
  accent: "#E4572E",
  error: "#E52600",
  errorBg: "#FEF2F2",
  headerBg: "#0D0D0D",
  instructorMeta: "#987451",
  linkAccent: "#795C40",
  /** Logo mark fills from SVG assets */
  logoOrange: "#f26739",
  logoBlue: "#24abe2",
  logoTextOnDark: "#FFFFFF",
  logoTextOnLight: "#0D0D0D",
} as const;
